/*eslint no-unused-vars: 0*/

import FabricCanvasTool from "./fabrictool";
import { linearDistance } from "./utils";

const fabric = require("fabric").fabric;

class Circle extends FabricCanvasTool {
  configureCanvas(props) {
    let canvas = this._canvas;
    canvas.isDrawingMode = false;
    canvas.selection = false;

    canvas.forEachObject(o => {
      o.selectable = false;
      o.evented = false;
      o.hasControls = false;
      o.hasBorders = false;
    });

    this._width = props.lineWidth;
    this._color = props.lineColor;
    this._fill = props.fillColor;
  }

  doMouseDown(o) {
    let canvas = this._canvas;
    if (this.circle) return; // If a circle already exists, return early

    this.isDown = true;
    let pointer = canvas.getPointer(o.e);
    [this.startX, this.startY] = [pointer.x, pointer.y];
    const fixedRadius = 100;

    this.circle = new fabric.Circle({
      left: this.startX,
      top: this.startY,
      originX: "center",
      originY: "center",
      strokeWidth: this._width, 
      stroke: this._color,
      fill: this._fill,
      selectable: false,
      evented: false,
      radius: fixedRadius,
      strokeUniform: true
    });

    canvas.add(this.circle);
    canvas.bringToFront(this.circle);
    canvas.requestRenderAll();
  }

  doMouseUp(o) {
    this.isDown = false;
    this.circle = null; // Reset the circle so a new one can be added on the next mouse down
  }
}

export default Circle;
